import { createContext, useContext } from "react";
import { MarkdownContent } from "@/components/ui/MarkdownContent";
import type { KuerzelDir } from "@/lib/kuerzel";

/**
 * The resolved Kürzel directory for the memo, provided ONCE at the top of the
 * memo tree (MemoPage, which has the QueryClient) and read here by every entry.
 * The default is an empty Map, so a MemoEntryRow rendered in isolation (unit
 * tests) reads it without a provider and never fetches — no QueryClient needed.
 */
export const KuerzelDirectoryContext = createContext<KuerzelDir>(new Map());

/**
 * MarkdownContent for memo bodies: the same renderer plus employee-Kürzel
 * highlighting (memo-only, so comments / board text stay untouched). Passes
 * `undefined` when the directory is empty so the highlight plugin is skipped.
 */
export function MemoMarkdown({ markdown }: { markdown: string }) {
  const kuerzel = useContext(KuerzelDirectoryContext);
  return (
    <MarkdownContent
      markdown={markdown}
      kuerzel={kuerzel.size ? kuerzel : undefined}
      // Aligns a top-level markdown list to the prose-point column (see .flow-md-list
      // in index.css) so a "- point" reads identically to a prose point in the memo.
      variant="memo"
    />
  );
}
